// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21Js7","colBig":"styles_colBig__4ODmP","colSmall":"styles_colSmall__3gCOP"};